import React from "react";
import styled, { keyframes } from "styled-components";

const LoadingScreen: React.FC = () => {
    return (
        <Container>
            <Loader />
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background: white;
`;

const SpinAnimation = keyframes`
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
`;

const Loader = styled.div`
    border: 0.5rem solid ${(props) => props.theme.colors.primary[100]};
    border-top: 0.5rem solid ${(props) => props.theme.colors.primary[500]};
    border-radius: 100%;
    width: 4rem;
    height: 4rem;
    animation-name: ${SpinAnimation};
    animation-duration: 0.5s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
`;

export default LoadingScreen;
